export enum CreditFlow {
  All = 0,
  Credit = 1,
  Debit = 2,
}
